    // useDynamicFilters.js
import { useState, useEffect } from "react";

/**
 * Hook pour gérer N filtres dynamiques avec persistance et filtrage
 * items: tableau de données
 * filterDefinition: [{ key, label, source }]
 */
export function useDynamicFilters(items, filterDefinition) {
  const [filters, setFilters] = useState({});
  const [options, setOptions] = useState({});

  // Restaure les filtres depuis localStorage
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("filters") || "{}");
    setFilters(stored);
  }, []);

  // Génère les options disponibles pour chaque filtre
  useEffect(() => {
    const result = {};
    filterDefinition.forEach(({ key, source }) => {
      result[key] = [...new Set(items.flatMap(item => item[source] || []))].sort();
    });
    setOptions(result);
  }, [items, filterDefinition]);

  // Met à jour un filtre et sauvegarde
  const updateFilter = (key, value) => {
    const updated = { ...filters, [key]: value };
    setFilters(updated);
    localStorage.setItem("filters", JSON.stringify(updated));
  };

  // Applique le filtrage sur les items
  const filteredItems = items.filter(item =>
    filterDefinition.every(({ key, source }) => {
      const value = filters[key];
      return !value || (item[source] && item[source].includes(value));
    })
  );

  return { filters, options, updateFilter, filteredItems };
}
